module.exports = __webpack_public_path__ + "18fe49732e94cdc4fa842fd2bff1a400.svg";